package com.milta.feature.spreadsheetimport.data.repository

import com.milta.feature.spreadsheetimport.data.remote.SpreadsheetImportApi
import com.milta.feature.spreadsheetimport.data.remote.dto.toDomain
import com.milta.feature.spreadsheetimport.domain.entity.SpreadsheetImportResult
import com.milta.feature.spreadsheetimport.domain.repository.SpreadsheetImportRepository

class SpreadsheetImportRepositoryImpl(private val api: SpreadsheetImportApi) : SpreadsheetImportRepository {
    override suspend fun importSpreadsheet(fileBytes: ByteArray, fileName: String): SpreadsheetImportResult =
        api.importSpreadsheet(fileBytes, fileName).toDomain()
}
